import type { ComponentPropsWithoutRef, Ref } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from './Button';

export const ButtonDelete = forwardRef(function ButtonDeleteRender(
	props: ComponentPropsWithoutRef<typeof Button>,
	ref: Ref<HTMLButtonElement>
) {
	const { t } = useTranslation('common');

	return (
		<Button ref={ref} color="error" {...props} data-testid="button-delete">
			{props.children || t('buttons.delete')}
		</Button>
	);
});
